import * as Immutable from "immutable"
import { BaseEntity } from "../../baseEntity"

export abstract class ListItem extends BaseEntity {

  protected readonly TEXT = "text";
  protected readonly VALUE = "value";
  protected readonly SELECTED = "selected";

  get text(): string { return this.getInternalValue<string>(this.TEXT); }
  setText(text: string): this { return this.setInternalValue(this.TEXT, text); }

  get value(): string { return this.getInternalValue<string>(this.VALUE); }
  setValue(value: string): this { return this.setInternalValue(this.VALUE, value); }

  get selected(): boolean { return this.getInternalValue<boolean>(this.SELECTED); }
  setSelected(selected: boolean): this { return this.setInternalValue(this.SELECTED, selected); }

}